var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPatternOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234,
    height: 450,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-pattern-one_svg__clip0_542_1629)",
    fill: "#F87C56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.958 449.996H210.852c-10.017 0-18.476-8.144-18.476-17.781V164.359h17.493v267.639c.255.282.605.459.983.497h102.106v17.501z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.688 212.942l-17.493-.053.245-80.011H0L.318 17.673C.318 7.938 8.152 0 17.784 0h24.585l-.06 90.568 270.642.052v17.501l-288.145-.056.06-90.564h-6.96a.35.35 0 00-.094.196l-.256 97.68h93.416l-.284 97.565z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.405 426.724h-17.493V157.387h-81.869a17.568 17.568 0 01-17.539-17.547v-24.459h123.853c9.506 0 17.536 7.539 17.536 16.468v157.996l54.125.259-.084 17.501-71.535-.35v-174.37H134.98v6.959a.084.084 0 00.031.045h99.394v286.835zM312.951 66.003H49.695v17.501h263.256v-17.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-pattern-one_svg__clip0_542_1629"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h313v450H0z"
  })))));
}
export default SvgIconPatternOne;